import React from "react";

function HotelCancellation() {
  return <div>HotelCancellation</div>;
}

export default HotelCancellation;
